import {
  Box,
  Button,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { updateGameHandler } from "../../service/GameService";
import { useFormik } from "formik";
import { useAppDispatch, useAppSelector } from "../../redux";
import { getAllCategories } from "../../service/CategoryService";
import { AppDispatch } from "../../redux/store";
import { useTranslation } from "react-i18next";
import { FormControlLabel, Switch } from "@mui/material";
import GamePreviewDialog from "./GamePreviewDialog";
import { uploadGamePicture } from "../../service/GameService";

const UpdateViewGame = () => {
  const [t] = useTranslation("global");
  const { gameId } = useParams();
  const query: any = new URLSearchParams(useLocation().search);
  const isEdit: string = query.get("isEdit");
  const navigate = useNavigate();
  const gamesData = useAppSelector((state) => state.games.games.results);
  const isMobile = useMediaQuery("(max-width:600px)");
  const [categoriesData, setCategoriesData] = useState<any[]>([]);
  const dispatch: AppDispatch = useAppDispatch();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(-1);
  const open = Boolean(anchorEl);
  const [id, setId] = useState("");

  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event: React.MouseEvent<HTMLElement>, index: number, id: string) => {
    setId(id);
    setSelectedIndex(index);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [initialValues, setInitialValues] = useState({
    gameName: "",
    gameCode: "",
    categoryId: "",
    gameDescription: "",
    instructions: "",
    thumbnailUrl: "",
    maxScore: 0,
    practiceSeconds: 10,
    active: true,
  });
  const [testing, setTesting] = useState(false);

  const fetchGames = async () => {
    let categories: any[] = [];
    if (categoriesData && categoriesData.length === 0) {
      categories = await getAllCategories(dispatch, isMobile, navigate);
      setCategoriesData(categories);
    }
    // Find game data
    const data = gamesData.find((game) => game.id === gameId);
    if (data) {
      setInitialValues({
        gameName: data.gameName,
        gameCode: data.gameCode,
        categoryId: data.categoryId?.categoryName,
        gameDescription: data.gameDescription,
        instructions: data.instructions || "",
        thumbnailUrl: data.thumbnailUrl || "",
        maxScore: data.maxScore ?? 0,
        practiceSeconds: data.practiceSeconds ?? 10,
        active: data.active !== false,
      });
      if (categories && categories.length > 0) {
        const categoryIndex = categories.findIndex(
          (category: any) => category.id === data.categoryId.id
        );
        setSelectedIndex(categoryIndex);
        setId(data.categoryId.id);
      }
    }
  };

  useEffect(() => {
    fetchGames();
  }, [isEdit, gameId]);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: async (values) => {
      const dataToBePassed = {
        gameName: values.gameName,
        gameCode: values.gameCode,
        categoryId: id,
        gameDescription: values.gameDescription,
        instructions: values.instructions,
        thumbnailUrl: values.thumbnailUrl,
        maxScore: Number(values.maxScore) || 0,
        practiceSeconds: Number(values.practiceSeconds) || 0,
        active: Boolean(values.active),
      };

      try {
        const response = await updateGameHandler(dataToBePassed, gameId);
        if (response?.status === 200 && response.statusText === "OK") {
          handleGoBack();
        }
      } catch (error) {
        console.log("Update game error: ", error);
      }
    },
  });

  const handleGoBack = () => {
    navigate("/game");
  };
  console.log("aaa: ", formik.values.categoryId);

  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginX: "10%",
          marginBottom: "5%",
        }}
      >
        <h1>
          {isEdit === "true" ? t("common.edit") : t("common.view")} {t("updateview.t1")}
        </h1>

        <Box component="form" onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                autoFocus
                required
                fullWidth
                id="gameName"
                name="gameName"
                label={t("fields.gameName")}
                type="text"
                variant="outlined"
                onChange={formik.handleChange}
                value={formik.values.gameName}
                disabled={isEdit !== "true"}
                error={formik.touched.gameName && Boolean(formik.errors.gameName)}
                helperText={formik.touched.gameName && formik.errors.gameName}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                id="gameCode"
                name="gameCode"
                label={t("fields.gameCode")}
                type="text"
                variant="outlined"
                onChange={formik.handleChange}
                value={formik.values.gameCode}
                disabled={isEdit !== "true"}
                error={formik.touched.gameCode && Boolean(formik.errors.gameCode)}
                helperText={formik.touched.gameCode && formik.errors.gameCode}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                id="gameDescription"
                name="gameDescription"
                label={t("fields.gameDescription")}
                type="text"
                variant="outlined"
                onChange={formik.handleChange}
                value={formik.values.gameDescription}
                disabled={isEdit !== "true"}
                error={formik.touched.gameDescription && Boolean(formik.errors.gameDescription)}
                helperText={formik.touched.gameDescription && formik.errors.gameDescription}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                minRows={2}
                id="instructions"
                name="instructions"
                label={t("games.instructions")}
                helperText={t("games.instructionsHelp")}
                variant="outlined"
                onChange={formik.handleChange}
                value={formik.values.instructions}
                disabled={isEdit !== "true"}
                inputProps={{ maxLength: 300 }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                id="maxScore"
                name="maxScore"
                type="number"
                label={t("games.maxScore")}
                helperText={t("games.maxScoreHelp")}
                variant="outlined"
                onChange={formik.handleChange}
                value={formik.values.maxScore}
                disabled={isEdit !== "true"}
                inputProps={{ min: 0 }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                id="practiceSeconds"
                name="practiceSeconds"
                type="number"
                label={t("games.practiceSeconds")}
                helperText={t("games.practiceSecondsHelp")}
                variant="outlined"
                onChange={formik.handleChange}
                value={formik.values.practiceSeconds}
                disabled={isEdit !== "true"}
                inputProps={{ min: 0, max: 30 }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={<Switch color="warning" checked={Boolean(formik.values.active)} onChange={(event) => formik.setFieldValue("active", event.target.checked)} disabled={isEdit !== "true"} />}
                label={t("games.active")}
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {formik.values.thumbnailUrl && <img src={formik.values.thumbnailUrl} alt="" style={{ width: 72, height: 72, objectFit: "cover", borderRadius: 12 }} />}
              {isEdit === "true" && (
                <Button variant="outlined" component="label" >
                  {t("games.uploadPicture")}
                  <input
                    hidden
                    type="file"
                    accept="image/png,image/jpeg,image/webp"
                    onChange={async (event) => {
                      const file = event.target.files?.[0];
                      if (!file) return;
                      const url = await uploadGamePicture(file, isMobile);
                      if (url) formik.setFieldValue("thumbnailUrl", url);
                    }}
                  />
                </Button>
              )}
              <Button variant="contained" sx={{ "&:hover": { backgroundColor: "#D55A07" } }} onClick={() => setTesting(true)} disabled={!formik.values.gameCode}>
                {t("games.test")}
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <List
                component="nav"
                aria-label="Device settings"
                sx={{ bgcolor: "background.paper" }}
              >
                {categoriesData && (
                  <ListItemButton
                    id="lock-button"
                    disabled={isEdit !== "true"}
                    aria-haspopup="listbox"
                    aria-controls="lock-menu"
                    aria-label="when device is locked"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClickListItem}
                    sx={{
                      border: "1px solid #ccc", // Adding border to the menu
                      borderRadius: "8px",
                      paddingY: "12px",
                      "& .MuiMenuItem-root": {
                        padding: "12px 24px", // Increase padding for larger menu items
                        fontSize: "1rem", // Increase font size if needed
                      },
                    }}
                  >
                    <ListItemText
                      primary={
                        categoriesData.length > 0 &&
                        selectedIndex !== -1 &&
                        categoriesData[selectedIndex]
                          ? categoriesData[selectedIndex].categoryName
                          : "Select Category"
                      }
                    />
                  </ListItemButton>
                )}
              </List>
              {categoriesData && (
                <Menu
                  id="lock-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "lock-button",
                    role: "listbox",
                  }}
                  PaperProps={{
                    sx: {
                      width: "260px", // Adjust width as needed
                      maxHeight: "400px", // Adjust height as needed
                    },
                  }}
                >
                  {categoriesData.map((category: any, index) => (
                    <MenuItem
                      key={category.id}
                      value={category.id}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index, category.id)}
                    >
                      {category.categoryName}
                    </MenuItem>
                  ))}
                </Menu>
              )}
            </Grid>
          </Grid>

          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={handleGoBack}
              variant="outlined"
              sx={{
                mr: 1,
                "&:hover": { borderColor: "#d55a07" },
              }}
            >
              {t("updateview.t2")}
            </Button>

            {isEdit === "true" && (
              <Box>
                <Button
                  onClick={handleGoBack}
                  variant="outlined"
                  sx={{
                    mr: 1,
                    "&:hover": { borderColor: "#d55a07" },
                  }}
                >
                  {t("updateview.t3")}
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ "&:hover": { backgroundColor: "#d55a07" } }}
                >
                  {t("updateview.t4")}
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      <GamePreviewDialog gameCode={formik.values.gameCode} seconds={Number(formik.values.practiceSeconds) || 10} open={testing} onClose={() => setTesting(false)} />
    </Layout>
  );
};

export default UpdateViewGame;
